import { NgModule } from '@angular/core';
import { TypeSafeMatCellDefDirective } from './type-safe-cdk-cell-dev.directive';

@NgModule({
  declarations: [TypeSafeMatCellDefDirective],
  exports: [TypeSafeMatCellDefDirective],
})
export class DirectivesModule {}
